import { useEffect, useState } from "react";
import { COMPANY } from "@/data/content";

// Premium full-screen loading screen: shows ONLY the logo (no text) on a
// deep-black background with a subtle teal/mint glow + scale pulse, then
// fades out smoothly once the site has finished loading.
const Loader = () => {
  const [hidden, setHidden] = useState(false);
  const [removed, setRemoved] = useState(false);

  useEffect(() => {
    const start = Date.now();
    const MIN_DISPLAY = 900; // keep the loader graceful, not a flash
    const finish = () => {
      const wait = Math.max(0, MIN_DISPLAY - (Date.now() - start));
      window.setTimeout(() => setHidden(true), wait);
    };

    if (document.readyState === "complete") {
      finish();
    } else {
      window.addEventListener("load", finish);
      // safety fallback in case the load event is missed
      const fallback = window.setTimeout(() => setHidden(true), 3000);
      return () => {
        window.removeEventListener("load", finish);
        window.clearTimeout(fallback);
      };
    }
  }, []);

  useEffect(() => {
    if (!hidden) return;
    const t = window.setTimeout(() => setRemoved(true), 600); // match fade duration
    return () => window.clearTimeout(t);
  }, [hidden]);

  if (removed) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="app-loader"
      className="fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-500 ease-out"
      style={{
        background: "#020606",
        opacity: hidden ? 0 : 1,
        pointerEvents: hidden ? "none" : "auto",
      }}
    >
      <img
        src={COMPANY.logo}
        alt="Prince Trading Impex"
        className="pti-loader-logo h-28 w-28 object-contain sm:h-36 sm:w-36"
        draggable="false"
      />
    </div>
  );
};

export default Loader;
